import { render, staticRenderFns } from "./RmaComments.vue?vue&type=template&id=8dc8c946&"
import script from "./RmaComments.vue?vue&type=script&lang=js&"
export * from "./RmaComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports